var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 36 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m28.426 10.222-5.08-9.142a1.668 1.668 0 0 0-2.915 1.618l4.18 7.524H11.388l4.18-7.524a1.668 1.668 0 0 0-2.915-1.618l-5.08 9.142H1.89a1.667 1.667 0 0 0 0 3.334h1.244l1.2 14.397c.263 3.143 2.938 5.603 6.092 5.603h15.153c3.153 0 5.829-2.46 6.09-5.603l1.2-14.397h1.245a1.667 1.667 0 1 0-.002-3.334z",
    clipRule: "evenodd"
  })));
};
export default SvgBasket;